import Component from '@cell/cell-core/component/component';
import './share-button.scss';

class ShareButton extends Component {
  constructor() {
    super();

    this.handleCopyUrlClick = this.handleCopyUrlClick.bind(this);
  }

  componentDidMount() {
    this.on('click', this.handleCopyUrlClick);
  }

  async handleCopyUrlClick() {
    await navigator.clipboard.writeText(window.location.href);

    // Notify other components that the URL has been copied.
    this.emit('copied-url', { message: this.parsedDataset.message });
  }
}

customElements.define('share-button', ShareButton);
